import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const useMaterialDetailTypes = defineStore('material-detail-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.compositionMaterial_GetCompositionMaterialDetailTypes,
    dto: 'CompositionMaterialDetailTypeDto',
    create: api.compositionMaterial_AddCompositionMaterialDetailType,
    delete: api.compositionMaterial_DeleteCompositionMaterialDetailType,
    update: api.compositionMaterial_UpdateCompositionMaterialDetailType,
    signalR: 'MaterialDetailTypeUpdate',
  });
  const { loaded } = globalStoreBase;

  async function create(name: string) {
    const existingDetailTypeWithSameName = loaded.value?.find(
      (detailType) => detailType.name?.toLowerCase() === name.toLowerCase()
    );

    if (existingDetailTypeWithSameName) {
      return existingDetailTypeWithSameName;
    }

    return await globalStoreBase.create({ name });
  }

  return {
    ...globalStoreBase,
    loaded,
    create,
  };
});
